import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './NotificationsModal.module.css';
import { Notification } from '../../types/notifications';

interface NotificationsModalProps {
  isOpen: boolean;
  notifications: Notification[];
  onClose: () => void;
}

const NotificationsModal: React.FC<NotificationsModalProps> = ({ isOpen, notifications, onClose }) => {
  const navigate = useNavigate();

  if (!isOpen || !notifications || notifications.length === 0) {
    return null;
  }

  const handleNotificationClick = (notification: Notification) => {
    const { category, data } = notification;
    const jobId = data?.job_id;

    // Close modal first
    onClose();

    // Navigate based on notification category
    switch (category) {
      case 'job_no_interviews':
      case 'job_new_activity':
      case 'interview_reminder':
      case 'interview_action_needed':
      case 'offer_signed':
        if (jobId) {
          navigate(`/ats/${jobId}`);
        } else {
          // Fallback to dashboard if job_id is missing
          navigate('/dashboard');
        }
        break;
      case 'new_invoice':
      case 'pending_invoice':
        navigate('/billing');
        break;
      default:
        // Default to dashboard for unknown categories
        navigate('/dashboard');
    }
  };

  const formatDate = (dateString: string) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.header}>
          <h2 className={styles.title}>Notifications</h2>
          <button className={styles.closeButton} onClick={onClose} aria-label="Close">
            ×
          </button>
        </div>
        <div className={styles.content}>
          {notifications.map((notification) => (
            <div
              key={notification.id}
              className={styles.notificationItem}
              onClick={() => handleNotificationClick(notification)}
            >
              <div className={styles.notificationHeader}>
                <h3 className={styles.notificationTitle}>{notification.title}</h3>
                <span className={styles.notificationDate}>
                  {formatDate(notification.created_at)}
                </span>
              </div>
              <p className={styles.notificationMessage}>{notification.message}</p>
            </div>
          ))}
        </div>
        <div className={styles.footer}>
          <button className={styles.closeFooterButton} onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotificationsModal;

